module.exports = __webpack_public_path__ + "static/media/logo_150.f22bfe21.png";